module.exports = __webpack_public_path__ + "static/updateDataTitle-4a551bef6cdf9007776d30a92d78c8b6.png";